import useJwt from '@/auth/jwt/useJwt'

export default function isAuthorised({to, next}) {
  if (!useJwt.getToken()) {
    return next({name: 'login', query: {redirectUrl: to.path},})
  }

  return next()
}
